export const iut = {
  start: "2020-06-01",
  end: "2100-01-01",
};
export const law = {
  start: "2024-06-17T00:00:00",
  end: "2024-06-20T23:59:59",
};
export const em = {
  start: "2020-06-01",
  end: "2100-01-01",
};
export const other = {
  start: "2020-06-01",
  end: "2100-01-01",
};
export const sciencePo = {
  start: "2024-06-10",
  end: "2024-06-13T23:59:59",
};
